export default "__VITE_PUBLIC_ASSET__4e6703bb__"